import * as NavTreeToggle from '../nav_tree/nav_tree_toggle.js';
import * as BetaToggle from '../beta/beta_toggle';

const navTreeToggle = new NavTreeToggle({
    cookie: typeof navTreeUserPreferenceCookieName !== 'undefined' ? navTreeUserPreferenceCookieName : '',
    logUrl: typeof navTreeUserPreferenceLogUrl !== 'undefined' ? navTreeUserPreferenceLogUrl : '',
    homeUrl: typeof mediatelHomeUrl !== 'undefined' ? mediatelHomeUrl : ''
});

const betaToggle = new BetaToggle({
    cookie: typeof betaUserPreferenceCookieName !== 'undefined' ? betaUserPreferenceCookieName : '',
    logUrl: typeof betaUserPreferenceLogUrl !== 'undefined' ? betaUserPreferenceLogUrl : ''
})

document.addEventListener("DOMContentLoaded", function() {
    navTreeToggle.init('nav-tree-user-toggle');
    betaToggle.init('beta-user-toggle');
});
